<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="6" y="6" width="12" height="12" rx="3" fill="none" stroke="var(--stroke-color)" stroke-width="2"/>
  <rect x="22" y="6" width="12" height="12" rx="3" fill="none" stroke="var(--stroke-color)" stroke-width="2"/>
  <rect x="14" y="22" width="12" height="12" rx="3" fill="none" stroke="var(--stroke-color)" stroke-width="2"/>
  <line x1="18" y1="12" x2="22" y2="12" stroke="var(--stroke-color)" stroke-width="1.5" stroke-dasharray="2 2"/>
  <line x1="18" y1="18" x2="20" y2="22" stroke="var(--stroke-color)" stroke-width="1.5" stroke-dasharray="2 2"/>
</svg>
